import { round2 } from "../contexts/AppContext";
// import { parseNumber } from "../services/currencyService";

export function handleInputChange(e, cards, setCards, index) {
  // Validation
  if (!e || !e.target || index < 0 || index >= cards.length) {
    if (process.env.NODE_ENV === "development") {
      console.error('[PaymentHelpers] Invalid input parameters:', { e, index, cardsLength: cards?.length });
    }
    return;
  }

  let { name, value } = e.target;

  // Change caret color to default when the user starts typing
  // Note: This is a workaround - ideally should use CSS classes
  if (value && value.length > 0) {
    e.target.style.caretColor = "auto";
  } else {
    e.target.style.caretColor = "transparent";
  }

  if (name === "cardnumber") {
    // Format credit card number
    value = formatCreditCardNumber(value);
  }

  if (name === "expdate") {
    // Remove all non-numeric characters
    const numbersOnly = value.replace(/\D/g, '');
    // Limit to 4 digits
    const limited = numbersOnly.slice(0, 4);
    // Add / after 2 digits
    value = limited.length > 2 
      ? `${limited.slice(0, 2)}/${limited.slice(2)}`
      : limited;
  }

  try {
    const updatedCards = [...cards];
    const updatedCard = { ...cards[index], [name]: value };
    updatedCards[index] = updatedCard;

    setCards(updatedCards);
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error('[PaymentHelpers] Error updating cards:', error);
    }
  }
}

const formatCreditCardNumber = (value) => {
  if (!value || typeof value !== 'string') {
    return '';
  }
  
  // Remove all non-numeric characters
  const numbersOnly = value.replace(/\D/g, '');
  
  // Limit to 16 digits
  const limited = numbersOnly.slice(0, 16);
  
  // Add space every 4 digits
  const parts = limited.match(/.{1,4}/g);
  return parts ? parts.join(' ') : '';
};

// const blockInput = (index) => {
//   const currentCardWrapper = document.getElementById(
//     `new-card-number-${index}`
//   );

//   let inputs = currentCardWrapper.getElementsByTagName("input");

//   for (let i = 0; i < inputs.length; i++) {
//     // Block all inputs except amount for repayment from the same card
//     if (inputs[i].name !== "amount") {
//       inputs[i].readOnly = true;
//     }
//   }
// };

export const getTotalFeesCount = (tashFees) => {
  if (!Array.isArray(tashFees)) {
    return 0;
  }
  
  try {
    return tashFees.reduce((total, entry) => {
      if (!entry || typeof entry.tashFee !== 'number') {
        return total;
      }
      return total + entry.tashFee;
    }, 0);
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error('[PaymentHelpers] Error calculating total fees:', error);
    }
    return 0;
  }
};

export const getTotalSumPaid = (sumpaid, tashfeesCount) => {
  try {
    const sum = typeof sumpaid === 'number' ? sumpaid : 0;
    const fees = typeof tashfeesCount === 'number' ? tashfeesCount : 0;
    return round2(sum - fees);
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error('[PaymentHelpers] Error calculating total sum paid:', error);
    }
    return 0;
  }
};
